import "./PageTitle.scss";
import { ReactNode, useRef, useState } from "react";
import { ContextMenu } from "primereact/contextmenu";
import { MenuItem } from "primereact/menuitem";
import { useTranslation } from "react-i18next";
import PermissionCheck from "../../Components/PermissionCheck";
import SavedFilterDialogs from "../../Components/Template/PageTitle/SavedFilterDialogs";
import { useSavedFilterScope } from "../../Components/Template/PageTitle/SavedFilterScopeContext";
import { DASHLY_PERMISSIONS } from "../../Util/dashlyPermissions";
import { PageHeaderTitleProps, usePageHeader } from "../../Components/Template/PageTitle/PageContext";

const resolveField = (
    field: PageHeaderTitleProps | undefined,
    t: (key: string) => string,
): ReactNode | undefined => {
    if (field?.value == null || field.value === "") {
        return undefined;
    }
    if (field.translationKey && typeof field.value === "string") {
        return t(field.value);
    }
    return field.value;
};

const PageTitle = () => {
    const { t } = useTranslation();
    const { pageHeader } = usePageHeader();
    const { scope } = useSavedFilterScope();
    const contextMenuRef = useRef<ContextMenu>(null);
    const [saveOpen, setSaveOpen] = useState(false);
    const [manageOpen, setManageOpen] = useState(false);
    const { title, subtitle, actions } = pageHeader;

    const resolvedTitle = resolveField(title, t);
    const resolvedSubtitle = resolveField(subtitle, t);
    const hasTitle = resolvedTitle != null && resolvedTitle !== "";
    const hasSubtitle = resolvedSubtitle != null && resolvedSubtitle !== "";
    const showHeader = hasTitle || hasSubtitle || Boolean(actions);

    if (!showHeader) {
        return null;
    }

    const menuItems: MenuItem[] = [
        {
            label: t("savedFilter.action.saveCurrent"),
            icon: "pi pi-save",
            command: () => setSaveOpen(true),
        },
        {
            label: t("savedFilter.action.manage"),
            icon: "pi pi-list",
            command: () => setManageOpen(true),
        },
    ];

    return (
        <>
            <header
                className="page-title"
                onContextMenu={(event) => {
                    if (!scope || !PermissionCheck(DASHLY_PERMISSIONS.SAVED_FILTER_USE)) {
                        return;
                    }
                    event.preventDefault();
                    contextMenuRef.current?.show(event);
                }}
            >
                {(hasTitle || hasSubtitle) && (
                    <div className="page-title__heading">
                        {hasTitle && (
                            <h1 className="page-title__title">
                                {title.icon && <i className={title.icon} aria-hidden />}
                                {resolvedTitle}
                            </h1>
                        )}
                        {hasSubtitle && (
                            <p className="page-title__subtitle">{resolvedSubtitle}</p>
                        )}
                    </div>
                )}
                {actions && <div className="page-title__actions">{actions}</div>}
            </header>
            <ContextMenu model={menuItems} ref={contextMenuRef} />
            <SavedFilterDialogs
                scope={scope}
                saveOpen={saveOpen}
                manageOpen={manageOpen}
                onCloseSave={() => setSaveOpen(false)}
                onCloseManage={() => setManageOpen(false)}
            />
        </>
    );
};

export default PageTitle;
